// import logger from '@/services/logger';

/**
 * The storage is in charge to persist data into browser storage
 */
export default {
  storage_name: 'wever_app',

  /**
   * Get storage data
   *
   * @return {object}
   */
  get data() {
    var LS_weverApp = localStorage.getItem(this.storage_name);

    if (null !== LS_weverApp) {
      return JSON.parse(decodeURIComponent(LS_weverApp));
    }

    return {};
  },

  delete: function _delete() {
    localStorage.removeItem(this.storage_name);
  },

  /**
   * Save data in storage
   *
   * @param {*} data
   */
  set data(data) {
    localStorage.setItem(this.storage_name, encodeURIComponent(JSON.stringify(data)));
  },

  /**
   * Save data in storage interface
   *
   * @param {string} key
   *
   * @return {*}
   */
  get: function get(key) {
    return this.data[key];
  },

  /**
   * Check if a key exist in storage
   *
   * @param {string} key
   *
   * @return {boolean}
   */
  has: function has(key) {
    return this.data[key] !== undefined;
  },

  /**
   * Set value into storage
   *
   * @param {string} key
   * @param {*}      value
   *
   * @return {self}
   */
  set: function set(key, value) {
    var data = this.data;
    data[key] = value;
    this.data = data;
    return this;
  },

  /**
   * Remove value of key from storage
   *
   * @param {string}  key
   *
   * @return {self}
   */
  unset: function unset(key) {
    var data = this.data;
    delete data[key];
    this.data = data;
    return this;
  }
};